import {
  Container,
  Title,
  CategoriesTitle,
  Row,
  ArticlesContainer,
  CategoriesContainer,
  TrendingJobsWrapper,
} from './styles';
import ArticleCard from '@/containers/Blog/components/ArticleCard/ArticleCard';
import JobCategoryCard from '@/containers/Blog/components/JobCategoryCard/JobCategoryCard';
import BlogPagination from './components/BlogPagination/BlogPagination';
import dynamic from 'next/dynamic';
import { ArticleType } from '@/pages/blog';

const NewsletterSubscribeCard = dynamic(
  () => import(`./components/NewsletterSubscribeCard/NewsletterSubscribeCard`),
);
const TrendingJobs = dynamic(
  () => import(`./components/TrendingJobs/TrendingJobs`),
);

interface IBlog {
  articles: ArticleType[];
  categories: any[];
  lastPage: number;
  activeCategoryName: string;
  activeCategorySlug: string;
}

const Blog = ({
  articles,
  categories,
  lastPage,
  activeCategoryName,
  activeCategorySlug,
}: IBlog) => {
  return (
    <Container>
      <Row>
        <ArticlesContainer>
          {activeCategoryName ? (
            <Title>{activeCategoryName}</Title>
          ) : (
            <Title>Blog</Title>
          )}
          {articles.length
            ? articles.map((article: any) => {
                const {
                  title,
                  description,
                  category,
                  postDate,
                  author,
                  preview,
                  slug,
                } = article?.fields;
                return (
                  <ArticleCard
                    key={title}
                    title={title}
                    description={description}
                    category={category?.fields?.name}
                    postDate={postDate}
                    author={author}
                    preview={preview?.fields?.file?.url}
                    alt={preview?.fields?.title}
                    slug={slug}
                  />
                );
              })
            : null}
          <BlogPagination lastPage={lastPage} />
        </ArticlesContainer>
        <CategoriesContainer>
          <CategoriesTitle>Categories</CategoriesTitle>
          {categories.length &&
            categories.map(({ fields: { slug, name, icon } }) => (
              <JobCategoryCard
                key={slug}
                category={{
                  slug,
                  name,
                  icon,
                }}
                activeCategorySlug={activeCategorySlug}
              />
            ))}
          <NewsletterSubscribeCard />
          <CategoriesTitle>Trending Jobs</CategoriesTitle>
          <TrendingJobsWrapper>
            <TrendingJobs />
          </TrendingJobsWrapper>
        </CategoriesContainer>
      </Row>
    </Container>
  );
};

export default Blog;
